"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amplitudeIdentifyGroupOperationProcessors = exports.amplitudeIdentifyOperationProcessors = exports.defaultAmplitudeOperationProcessor = void 0;
const constants_1 = require("gather-http-common/dist/src/public/metrics/constants");
const ramda_1 = require("ramda");
exports.defaultAmplitudeOperationProcessor = {
    isValidValue: (value) => value !== undefined,
    processValue: ramda_1.identity,
};
const isNotUndefinedAndNotBoolean = (value) => value !== undefined && typeof value !== "boolean";
const appendAndPreInsertAmplitudeIdentifyOperationsHandler = {
    isValidValue: isNotUndefinedAndNotBoolean,
    processValue: ramda_1.identity,
};
const isStringOrNumber = (value) => typeof value === "string" || typeof value === "number";
exports.amplitudeIdentifyOperationProcessors = {
    [constants_1.AmplitudeIdentifyOperations.UNSET]: {
        isValidValue: (value) => value === undefined,
        processValue: ramda_1.identity,
    },
    [constants_1.AmplitudeIdentifyOperations.ADD]: {
        isValidValue: isStringOrNumber,
        processValue: (0, ramda_1.partial)(Number, []),
    },
    [constants_1.AmplitudeIdentifyOperations.APPEND]: appendAndPreInsertAmplitudeIdentifyOperationsHandler,
    [constants_1.AmplitudeIdentifyOperations.PRE_INSERT]: appendAndPreInsertAmplitudeIdentifyOperationsHandler,
};
exports.amplitudeIdentifyGroupOperationProcessors = {
    [constants_1.AmplitudeGroupIdentifyOperations.UNSET]: {
        isValidValue: (groupPropertyValue) => groupPropertyValue === undefined,
        processValue: ramda_1.identity,
    },
    [constants_1.AmplitudeGroupIdentifyOperations.ADD]: {
        isValidValue: isStringOrNumber,
        processValue: (0, ramda_1.partial)(Number, []),
    },
    [constants_1.AmplitudeGroupIdentifyOperations.APPEND]: {
        isValidValue: isNotUndefinedAndNotBoolean,
        processValue: ramda_1.identity,
    },
};
//# sourceMappingURL=amplitudeOperationsProcessors.js.map